/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import React, { useCallback, useContext } from "react";
import { UserDetailsContext } from "../../context/userDetails";
import { LanguageContext } from "../../context/languageContext";
import faceScanVideo from "../../assets/video/measurement-progress.mp4";
import faceScanVideoMale from "../../assets/video/male-measurement-progress.mp4";
import { CLOTHING_CUSTOM_SCAN, LanguageKeys, SWAN_VISION_AI, HeaderType, GENDER_TYPE, SIXCBD32_SHOP_DOMAIN } from "../../vars";
import SpecificButton from "../../components/specificButton/SpecificButton";
import { createRedirectUrl, encodingURL } from "../../utils/util";
import Header from "../../components/header/Header";
import useShopType from "../../customHook/useShopType";
import useIsCustom from "../../customHook/useIsCustom";

function ThankYouScreen() {
	const { shopDomain, scanType, shopifyRedirectUrl, email, gender } = useContext(UserDetailsContext);
	const { translate } = useContext(LanguageContext);
	const { isIdntfy, isConsumerTryon, isMyknitever, isSwanExt } = useShopType();

	const handleRedirect = () => {
		let redirectUrl = shopifyRedirectUrl;
		if (!isMyknitever && !isSwanExt) {
			redirectUrl = createRedirectUrl({ url: shopifyRedirectUrl, email: encodingURL(email) });
		}
		if (redirectUrl) {
			window.location.href = redirectUrl;
		} else if (isMyknitever || isSwanExt) {
			window.location.href = SWAN_VISION_AI;
		} else {
			window.location.href = window.location.origin;
		}
	};

	const handleShopTitle = useCallback(() => {
		if (!shopDomain) {
			return "";
		}
		if (shopDomain === "aldeno-laguna-clothing.myshopify.com") {
			return "https://houseofaldeno.com";
		}
		if (shopDomain?.includes("7till8") || shopDomain?.includes("7to8wetsuits")) {
			return translate(LanguageKeys.sevenTillEight);
		}
		if (shopDomain?.includes("rhodes-beckett") || shopDomain?.includes("rhodesbeckett")) {
			return translate(LanguageKeys.Rhodes_and_Beckett);
		}
		if (shopDomain?.includes("adidas")) {
			return "";
		}
		return  shopDomain;
	}, [shopDomain]);
	const isCustom = useIsCustom();

	return (
		<div className={`flex-col flex items-center  text-center w-full h-full ${isCustom && `justify-center`} ${isIdntfy && `justify-between`}`}>
			<Header whatTypeHeader={isIdntfy ? HeaderType.IdntfyStore : null} />
			<div className="px-4 w-full flex flex-col flex-1 justify-center">
				<div className="w-full h-full flex text-center flex-col justify-between items-center bg-primary rounded-t-[30px]  py-4">
					<div className="w-full h-full flex flex-col">
						<Header whatTypeHeader={HeaderType.Deafult} heading=" " hideSubHeading={false} headerTop="logoOnlyLeft" />
						<h2 className="mt-5 text-[26px] leading-[1.2]">Your measurements are complete!</h2>
						<div className="flex items-center justify-center flex-1">
							<video key={gender} className="max-h-[calc(100vh-450px)] mx-auto w-full object-contain border-none" muted loop autoPlay playsInline>
								<source src={gender === GENDER_TYPE.MALE ? faceScanVideoMale : faceScanVideo} type="video/mp4" />
							</video>
						</div>
						{shopDomain?.includes("adidas")? (
							<h2 className="text-[22px] leading-[1.2] mb-5 mx-auto max-w-[280px] ">Your measurements have been shared with Adidas.</h2>
						) : shopDomain === SIXCBD32_SHOP_DOMAIN ? <h2 className="text-[22px] leading-[1.2] mb-5 mx-auto max-w-[280px] ">Your measurements are on their way to your inbox.</h2> : (
							<h2 className="text-[22px] leading-[1.2] mb-5 mx-auto max-w-[280px] ">The results have been shared with the {handleShopTitle(shopDomain)} & a copy will reach your inbox shortly. </h2>
						)}

						{(isMyknitever || isSwanExt || scanType === CLOTHING_CUSTOM_SCAN || isConsumerTryon || isIdntfy) && (
							<div className="mt-4 flex justify-center">
								<SpecificButton btnSecondary className="!w-[140px] mx-auto" buttonText="Close" buttonFunc={handleRedirect} />
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default ThankYouScreen;
